/*
 * Da de baja la titularidad de un medio de pago.
 * Es llamado en el perfil de usuario cuando empieza el proceso de baja del cliente
 * Es llamado en la titularidad de medios de pago
 */
import Vue from 'vue'

import ApiClientsService from 'js/services/api/api-clients.js'
import TicketingAdministrativeAreasService from 'js/services/api/ticketing/administrative-areas.js'
import QrDeactivationsService from 'js/services/api/passenger/qr-deactivations.js'

import Error from './_error.js'

import template from './index.pug'

export default {
  template: template(),
  components: {Error},
  props: {
    /*
     * Cuentas relacionadas con los municipios y el cliente, desactivaremos 1 de ellas
     * lleva el rut del cliente, nombre del municipio y el id del municipio.
     */
    initMedias: {
      type: Array,
      default: null
    },

    // Paso inicial, puede empezar en warning o confirm_disable.
    initStep: {
      type: String,
      required: true,
      validator: val => ['warning', 'confirm_disable'].indexOf(val) !== -1
    },

    // Process
    process: {
      type: String,
      required: true,
      validator: val => ['disable', 'unregister'].indexOf(val) !== -1
    }
  },
  data() {
    return {
      web_title: Vue.store.state.webTitle,
      administrativeAreas: [],
      submitButtonTranslate: '',
      currentStep: null,
      media: {},
      medias: [],
      paymentMedia: {},
      error: null,
      balance: 0
    }
  },
  computed: {
    mediaOptions() {
      return this.medias.map(media => {
        const administrativeArea = this.findAdministrativeArea(media.administrative_area_id)

        return {
          value: media,
          label: administrativeArea.consortium_name
        }
      })
    },

    showCancelButton() {
      const invalidSteps = ['error', 'success']
      return !invalidSteps.includes(this.currentStep)
    },

    buttonsClass() {
      return this.showCancelButton ? 'between' : 'center'
    }
  },
  async created() {
    this.initData()
    await this.loadAdministrativeAreas()
  },
  methods: {
    cancel() {
      this.$emit('close-disable-media-box')
    },

    initData() {
      this.currentStep = this.initStep
      this.medias = this.initMedias
      this.media = this.initMedias[0]
    },

    async loadAdministrativeAreas() {
      const params = {per: 0, template: 'with_municipality'}
      const {data} = await TicketingAdministrativeAreasService.index(params)
      this.administrativeAreas = data
    },

    findAdministrativeArea(administrativeAreaId) {
      return this.administrativeAreas.find(
        administrativeArea => administrativeArea.id === administrativeAreaId
      )
    },

    submit() {
      switch (this.currentStep) {
        case 'warning': {
          this.currentStep = 'select_media'
          break
        }

        case 'select_media': {
          this.currentStep = 'confirm_disable'
          break
        }

        case 'confirm_disable': {
          this.calculateBalanceStep()
          break
        }

        case 'positive_balance': {
          this.unsuscribeQr()
          break
        }

        case 'negative_balance': {
          this.calculateRechargeUrl()
          break
        }

        case 'error':
          this.cancel()
          break

        case 'success':
          this.redirectDefaultPage()
          Vue.store.dispatch('loadCurrentUser')
          break

        default: {
          break
        }
      }
    },

    calculateRechargeUrl() {
      const {media, findAdministrativeArea} = this

      const administrativeArea = findAdministrativeArea(media.administrative_area_id)

      this.$router.push({
        name: this.$municipality ? 'municipality-recharge-data' : 'recharge-data',
        params: {
          municipality_id: administrativeArea.municipality_id,
          media_type: '2',
          media_code: media.media_code
        }
      })
    },

    calculateBalanceStep() {
      const params = {
        administrative_area_id: this.media.administrative_area_id,
        rut: this.media.rut
      }

      ApiClientsService.clientMediaInfo(params).then(response => {
        this.paymentMedia = response.data.find(m => m.MediaType === '2')
        this.balance = this.paymentMedia.Balance

        // Si el QR está a 0 desactivamos directamente
        if (this.balance === 0) this.unsuscribeQr()
        if (this.balance > 0) this.currentStep = 'positive_balance'

        if (this.balance < 0) {
          this.currentStep = 'negative_balance'
          this.media.media_code = this.paymentMedia.CardSerialNumber
        }
      })
    },

    unsuscribeQr() {
      QrDeactivationsService.create(this.paymentMedia.id).then(() => {
        this.currentStep = 'success'
      }, response => {
        this.showErrorMessage(response.data.errors)
      })
    },

    redirectDefaultPage() {
      if (this.process === 'unregister') { return this.cancel() }
      this.cancel()
      return this.$router.push({name: 'municipality-data-payment-medias'})
    },

    showErrorMessage(errors) {
      this.error = errors.base
      this.currentStep = 'error'
    },

    currencyFilter(amount) {
      return Vue.options.filters.moverickCurrency(amount)
    }
  }
}
